"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MALE: 'male',
    FEMALE: 'female',
    UNSPECIFIED: 'unspecified',
};
//# sourceMappingURL=genders.js.map